// extracted by mini-css-extract-plugin
export default {"anmSelectContainer":"anmSelectQuery_anmSelectContainer__zg5fv","errorContainer":"anmSelectQuery_errorContainer__Q3Rdv","anmSelectLabel":"anmSelectQuery_anmSelectLabel__AH0Li"};